import React from 'react';
import './Toolbar.css';
import DrawerToggleButton from '../SideDrawer/DrawerToggle';
import logo from '../../img/logo.png';

const toolbar = props => {
    let headerClasses;

    if(props.page === 'Home') {
        headerClasses = 'toolbar toolbar-black';
    } else {
        headerClasses = 'toolbar';
    }

    return(
        <header className={headerClasses}>
            <nav className="toolbar__navigation">
                <div>
                    <DrawerToggleButton click={props.drawerClickHandler}/>
                </div>
                <div className="toolbar__logo">
                    <a href="/?Home">
                        <img alt="logo" src={logo}/>
                    </a>
                </div>
            </nav>
        </header>
    )
};

export default toolbar;